<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance "
         id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header modal_ti_header"></div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_failed_purchase_operator_purchase_failed }}</h1>
          <img class="modal_icon_alert"
               src="static/images/modals/failure.png" />
          <p>{{ getTranslations.home_modals_failed_purchase_operator_purchase_not_successful }}</p>
        </div>
        <div class="modal__footer">
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'failedPurchaseOperator',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/FailedPurchaseOperator.vue